import styled from 'styled-components';

export const MessageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  padding: 16px;

  overflow-y: auto;
  flex: 1;
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  gap: 32px;
  padding: 32px 16px;
  flex: 1;
`;

export const EmptyStateIconContainer = styled.div`
  width: 48px;
  height: 48px;

  border-radius: 50%;
  background-color: ${(props) => props.theme.colors?.greys?.darkest};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateIcon = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
`;

export const EmptyStateTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

export const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 400px;
`;

export const SuggestionCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: ${(props) => props.theme.colors?.greys?.lightest};
  border: 1px solid ${(props) => props.theme.colors?.greys?.light};
  border-radius: 8px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => (props.isDisabled ? '#FF4444' : props.theme.colors?.brand?.primary)};
    box-shadow: ${(props) =>
      props.isDisabled ? '0 2px 8px rgba(255, 68, 68, 0.1)' : '0 2px 8px rgba(38, 232, 136, 0.1)'};
  }
`;

export const SuggestionIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.theme.colors?.greys?.lighter};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const SuggestionText = styled.div`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.greys?.darkest};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
`;
